import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-heading font-semibold mb-4">汗汗漫画网</h3>
            <p className="text-sm text-background-300 leading-relaxed">
              专注收录好看的韩国漫画资源，提供最新最全的韩漫在线免费阅读服务，让漫画爱好者轻松追更热门作品。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">漫画分类</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider">热门分类</h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/shaonian" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">少年漫画</Link></li>
              <li><Link to="/category/shaonv" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">少女漫画</Link></li>
              <li><Link to="/category/danmei" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">耽美漫画</Link></li>
              <li><Link to="/category/qihuan" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">奇幻漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-mail-line"></i>
                <span>contact@hanhanmanhua.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-wechat-line"></i>
                <span>汗汗漫画官方</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; {currentYear} 汗汗漫画网 - 韩漫在线免费阅读平台。本站所有漫画均来自互联网，仅供学习交流使用。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-400 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-background-400 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
              <a href="#" className="text-xs text-background-400 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}